import { render, staticRenderFns } from "./settings-helper-components-3-resource-list.vue?vue&type=template&id=5364f25c&"
import script from "./settings-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
export * from "./settings-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports